import { render, staticRenderFns } from "./ModalMotorista.vue?vue&type=template&id=6c260b88"
import script from "./ModalMotorista.vue?vue&type=script&lang=js"
export * from "./ModalMotorista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports